var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      attrs: { role: "form" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.submit($event)
        }
      }
    },
    [
      _c("div", { staticClass: "form-group" }, [
        _c(
          "div",
          { staticClass: "input-group", staticStyle: { "max-width": "375px" } },
          [
            _c("input", {
              staticClass: "form-control",
              attrs: { type: "text", maxlength: "14", name: "gtin" },
              domProps: { value: _vm.search },
              on: {
                input: function($event) {
                  _vm.$emit("input", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "input-group-btn" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { disabled: _vm.error || _vm.empty, type: "submit" }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("search_button")) +
                      "\n        "
                  )
                ]
              )
            ])
          ]
        ),
        _vm._v(" "),
        _vm.example
          ? _c("span", { staticClass: "help-block" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("example_search")) + "\n      "
              ),
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.useExample($event)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.example))]
              )
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51efc6bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51efc6bc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchForm.vue
// module id = null
// module chunks = 